/**
 * @typedef Theme
 * @property {string} icon Icon to be used in the app
 * @property {string | null} iconLogin Specific icon for the login screen
 * @property {string | null} iconMenu Specific icon for the menu
 * @property {string} favicon
 * @property {ThemeColors} colors
 */

/**
 * @typedef ThemeColors
 * @property {string} accentColor
 * @property {string} accentColorDark
 */

/**
 * Gets a theme from the server
 *
 * @returns {Promise<Theme>}
 */
export async function getTheme() {
  let res = await fetch('/brand/theme.json');
  return await res.json();
}
